import { optionsRuolo, schemaEsperto } from 'components/forms-utils/utils'
import Privacy from 'components/registrazione/Privacy'
import { Form, Formik } from 'formik'
import { useRouter } from 'next/router'
import { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { api, CONTATTI_ESPERTO, hasPerm } from 'utils'
import { CONTATTAESPERTO } from 'utils/endpoint'
import { sendGTMData } from 'utils/gtm.js'
import Icon from './Icon'
import Login from './Login'
import Modal from './Modal'
import SelectDropdown from './SelectDropdown'
import Trans from './Trans'

function ModalContattaEsperto({ autore, modal, setModal }) {
  const { utente } = useSelector(state => state.utente)

  const router = useRouter()

  const formRef = useRef()

  const [login, setLogin] = useState(false)
  const [success, setSuccess] = useState(false)
  const [initialValues, setInitialValues] = useState({
    ruolo: '',
    email: utente.email,
    privacy: false,
    commerciale: false,
    profilazione: false,
  })

  const handleLogin = login => {
    setModal(false)
    setLogin(login)
  }

  useEffect(() => {
    if (hasPerm(utente, CONTATTI_ESPERTO)) {
      let newInitialValues = {
        ruolo: '',
        email: utente.email,
        privacy: false,
        commerciale: false,
        profilazione: false,
      }
      setInitialValues(newInitialValues)
    }
  }, [])

  const postData = async data => {
    data['autore'] = autore.id
    api.post(CONTATTAESPERTO, { data }).then(response => {
      const created = response.data['created']
      if (created) {
        sendGTMData({
          event: 'GAevent',
          eventID: '13',
          eventCategory: 'form',
          eventAction: 'contatto_esperto',
        })
        setModal(false)
        setSuccess(true)
      }
    })
  }

  const getActiveClass = (formik, name) => {
    return formik.values[name] ? 'valid' : ''
  }
  const getFieldClass = (formik, field) => {
    return formik.errors[field] ? 'error' : formik.values[field] !== '' ? 'valid' : ''
  }

  return (
    <>
      {modal &&
        (!utente || (utente && !utente.is_member) ? (
          <Modal
            isOpen={modal}
            alert={false}
            close={() => setModal(false)}
            classes="modal__content--wide"
          >
            <div className="modal__content__contatta">
              <p className="title">
                <Trans chiave="Hai una domanda? Abbonati a io+" />
              </p>
              <p className="disclaimer">
                <Trans chiave="Con io+ hai accesso alla consulenza dei nostri esperti di didattica, psicologia, pedagogia. Abbonati ora!" />
              </p>
              <a className="button button--primary button--red" href="/io-piu">
                Abbonati a io+
              </a>
              {!utente && (
                <p className="bottom">
                  Hai già l’abbonamento?{' '}
                  <a className="login" onClick={() => handleLogin(true)}>
                    Effettua l’accesso
                  </a>
                </p>
              )}
            </div>
          </Modal>
        ) : (
          <Modal
            isOpen={modal}
            alert={false}
            close={() => setModal(false)}
            classes="modal__content--wide"
          >
            <div className="modal__content__contatta">
              <p className="title-form">
                Scrivi a {autore.nome} {autore.cognome}
              </p>
              <p className="disclaimer-form">
                Hai un dubbio? Vuoi fare una domanda?
                <br /> Compila il form: {autore.nome} {autore.cognome} ti risponderà al più presto
                via email.
              </p>
              <Formik
                innerRef={formRef}
                enableReinitialize={true}
                initialValues={{
                  ...initialValues,
                }}
                validationSchema={schemaEsperto}
                onSubmit={(values, actions) => {
                  postData(values)
                }}
              >
                {({ validateForm, resetForm, handleSubmit, ...formik }) => (
                  <Form className="w-form" onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-12">
                        <div className="w-form__field-wrapper">
                          <input
                            type="email"
                            id="email"
                            name="email"
                            className={getFieldClass(formik, 'email')}
                            value={formik.values.email}
                            onChange={formik.handleChange}
                          />
                          <label htmlFor="email">Email*</label>
                          <span className="w-form__error">{formik.errors.email}</span>
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="w-form__field-wrapper">
                          <SelectDropdown
                            instanceId={`ruolo`}
                            placeholder={''}
                            options={optionsRuolo}
                            onChange={formik.handleChange}
                            value={formik.values.ruolo}
                            classes={getActiveClass(formik, 'ruolo')}
                          />
                          <label htmlFor="ruolo">Area di domanda*</label>
                          <span className="w-form__error">{formik.errors.nome}</span>
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="w-form__field-wrapper">
                          <textarea
                            rows="4"
                            cols="50"
                            placeholder="Scrivi qui la tua richiesta"
                            id="richiesta"
                            name="richiesta"
                            className={getFieldClass(formik, 'richiesta')}
                            value={formik.values.richiesta}
                            onChange={formik.handleChange}
                          />
                          <label htmlFor="richiesta">Domanda*</label>
                        </div>
                      </div>
                    </div>
                    <div className="privacy-richiesta">
                      <Privacy formik={formik} isRegistrazione={true}></Privacy>
                    </div>
                    <div className="button-submit-richiesta">
                      <input
                        type="submit"
                        value="Invia domanda"
                        disabled={!formik.isValid || !formik.dirty}
                        className=" button button--primary"
                      />
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </Modal>
        ))}
      {success && (
        <Modal isOpen={success} alert={false} close={() => setSuccess(false)}>
          <div className="modal__content__saved">
            <Icon id="check3" classes="icon--check" />
            <p className="title">
              <Trans chiave="Grazie per averci scritto!" />
            </p>
            <p className="disclaimer">
              <Trans chiave="Risponderemo al più presto via email." />
            </p>
          </div>
        </Modal>
      )}
      {login && <Login isOpen={login} next={router.asPath} setLogin={handleLogin} />}
    </>
  )
}

export default ModalContattaEsperto
